var React = require('react');

function Panic (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.25 4.444c0-.613.48-1.11 1.071-1.11.592 0 1.072.497 1.072 1.11v4.967l1.296.145 5.293 2.433c.568.267.91.855.91 1.5v4.844c-.031.911-.728 1.634-1.606 1.667H6.32c-.407 0-.792-.167-1.071-.478L0 14.856.793 14c.203-.233.493-.356.793-.356h.235l3.429 1.912V4.444zM6.321 0c2.367 0 4.286 1.99 4.286 4.444 0 1.667-.857 3.078-2.143 3.845V6.933a3.403 3.403 0 0 0 1.072-2.489c0-1.84-1.44-3.333-3.215-3.333S3.107 2.603 3.107 4.444c0 .99.418 1.878 1.072 2.49v1.355C2.893 7.522 2.036 6.11 2.036 4.444 2.036 1.99 3.954 0 6.32 0z","fill":"currentColor","fillRule":"nonzero"}));
}

Panic.defaultProps = {"width":"15","height":"20","viewBox":"0 0 15 20"};

module.exports = Panic;

Panic.default = Panic;
